import { SerializableSchema, z } from "@repo/utils";
import { InboxIdSchema } from "../inbox/z.js";

export const OrganizationIdSchema = z.string();
export const UserIdSchema = z.string();

export const SettingSchema = z.object({
    organizationId: z.nullable(OrganizationIdSchema),
    userId: z.nullable(UserIdSchema),
    key: z.string(),
    value: SerializableSchema,
    inboxId: z.nullable(InboxIdSchema),
});

export const InboxConnectionSchema = z.object({
    organizationId: OrganizationIdSchema,
    inboxId: InboxIdSchema,
});

export const LanguageSchema = z.enum(["DE", "EN"]);
